<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid" style="background: #EEEEEE; padding-top: 4px;" v-if="hasGame">
    <div class="row">
      <div class="category-head">
        <div class="back-link">
          <a @click="$router.back()">←</a>
        </div>
        <div class="category-title">
          <span class="topic-type">{{ tournamentType }}</span>
          <p>{{ tournamentName }} </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="question-no-show">
        <div v-for="questionNo in questionNoShow" :key="questionNo">
          {{ convertNumberToLangWise(questionNo) }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="count-down-question" v-if="timeCountShow" :style="countDownColor">
        {{ countDown }}s
      </div>
    </div>

    <div class="row">
      <div class="question-image" v-if="question.type === 'image'">
        <img :src="question.src_url" :alt="question.question_value">
      </div>
    </div>

    <div class="row">
      <div class="question" v-if="question.question_value">
        <div class="title">{{ question.question_value }}</div>
      </div>
    </div>

    <div class="row">
      <div class="questions-options">
        <div class="question-option"
             v-for="question_option in filterQuestionsOptions" :key="question_option.id"
             @click="setQuestionOption(question_option.id)"
             :style="[question_option.id === selectQuestionOption && submitAnswerClass
             ? submitAnswerClass : '']"
        >
          {{ question_option.value }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="d-flex justify-content-between fixed-bottom answer-btn-background" v-if="selectQuestionOption">
        <argon-button fullWidth color="danger"
                      variant="gradient"
                      class="my-4 mb-2 me-2"
                      @click="nextQuestionSet"
                      style="background: #8435E8; color: #FFFFFF; font-weight: bold;" v-if="! questionFinish">
          {{ $t('NEXT') }}
        </argon-button>
        <argon-button fullWidth color="danger"
                      variant="gradient"
                      class="my-4 mb-1 me-2"
                      @click="showResult"
                      style="background: #8435E8; color: #FFFFFF; font-weight: bold;" v-if="questionFinish">
          {{ $t('SEE_RESULT') }}
        </argon-button>
      </div>
    </div>
    <TournamentResultModal :modal-show="resultModalOpen" :result-played="resultPlayed" v-if="resultModalOpen"/>
  </div>
  <div class="d-flex justify-content-center align-items-center mt-2" v-else>
    No Question Found.
  </div>
</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import ArgonButton from "@/components/ArgonButton";
import TournamentResultModal from "@/views/components/TournamentResultModal";

export default {
  name: "TournamentPlay",
  components: {
    Loader,
    ArgonButton,
    TournamentResultModal,
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      tournamentType: this.$route.query.tournament_type,
      tournamentName: this.$route.query.tournament_name,
      game: [],
      questionNoShow: [],
      question: [],
      questionOptions: [],
      startQuestionNo: 0,
      questionsLeft: 0,
      countDown: 0,
      timeCountShow: true,
      selectQuestionOption: '',
      countDownColor: '',
      answerData: [],
      submitAnswerClass: '',
      correctAnswerFound: false,
      questionFinish: false,
      errorMsg: '',
      resultModalOpen: false,
      resultPlayed: [],
      hasGame: false,
      coinAmount: 0,
      gemAmount: 0,
      wallet: [],

    }
  },
  created() {
    this.getGame(this.$route.params.id);
    this.emitter.on('result-modal-close-event', (evt) => {
      this.resultModalOpen = evt.eventContent;
    });
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },

    getGame(tournament_id) {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/tournament/start', {tournament_id: tournament_id}, this.config)
          .then( response => {
            this.loaderActive = false;
            if(response.success) {
              this.hasGame = true;
              this.game = response.data;
              this.coinAmount = this.game.fifty_fifty_coin_amount;
              this.gemAmount = this.game.get_answer_gem_amount;
              this.wallet = this.game.wallet;
              this.question = this.game.question;
              this.questionOptions = this.question.options;
              this.startQuestionNo = this.question.question_no;
              this.questionsLeft = this.question.questions_left;
              this.noShow();
              this.countDown = this.game.playing_duration;
              this.countDownTimer();
            }

          })
          .catch(() => {
            this.loaderActive = false;
          });
    },

    noShow() {
      let questionNoCount = 1;
      for (let no = 0; no <= this.questionsLeft; no++, questionNoCount++) {
        if (questionNoCount === 6) {
          return this.questionNoShow;
        }
        this.questionNoShow.push(this.startQuestionNo);
        this.startQuestionNo++;
      }

      return this.questionNoShow;
    },

    countDownTimer () {
      if (! this.countDown) {
        this.timeCountShow = false;
        return;
      }

      if (this.countDown > 0) {
        if (this.countDown < 11) {
          this.countDownColor = { color: '#F42F75' }
        }
        setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer();
        }, 1000)
      }
    },

    setQuestionOption(select_option) {
      if (String(this.selectQuestionOption).length === 0) {
        this.selectQuestionOption = select_option;
        let data = {
          answer_id: this.selectQuestionOption,
          game_id: this.game.game_id,
          question_id: this.question.question_id,
          remaining_time: this.countDown
        }
        sendRequest('post', 'v2.0/tournament/submit', data, this.config)
            .then( response => {
              this.loaderActive = false;
              this.answerData = response.data;
              this.questionFinish = this.answerData.question_finished;
              this.submitAnswerClass = {
                'background': '#8435E8',
                'color': '#FFFFFF'
              }
              this.coinAmount = this.answerData.fifty_fifty_coin_amount;
              this.gemAmount = this.answerData.get_answer_gem_amount;
              if (this.questionFinish) {
                this.resultPlayed = this.answerData;
              }
            })
            .catch(() => {
              this.loaderActive = false;
            });
      }
    },

    nextQuestionSet() {
      this.selectQuestionOption = '';
      this.question = this.answerData.question;
      this.questionOptions = this.question.options;
      this.startQuestionNo = this.question.question_no;
      this.questionsLeft = this.question.questions_left;
      this.questionNoShow = [];
      if (! this.questionsLeft) {
        this.questionNoShow = [];
        this.questionNoShow.push(this.startQuestionNo);
      }
      this.resetCountDownAndOption();
    },

    resetCountDownAndOption() {
      this.submitAnswerClass = '';
      if (this.questionsLeft !== 0) {
        this.noShow();
      }
    },

    showResult() {
      this.resultModalOpen = true;
    },
  },
  computed: {
    filterQuestionsOptions() {
      return this.questionOptions;
    }
  }
}
</script>

<style scoped>

</style>
